import { PanelBody, PanelRow, RangeControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { BtnGroup, Label } from '../../../../Components';
import { aligns } from '../../utils/options';

const SwipeLayoutPanel = ({ attributes, setAttributes }) => {
    const { width, layoutAlign } = attributes;

    return <PanelBody title={__('Swipe Layout', 'swipe-n-buy')} initialOpen={false}>
        <RangeControl label={__('Width', 'swipe-n-buy')} value={width} onChange={(val) => setAttributes({ width: val })} min={2} max={100} />

        <PanelRow>
            <Label className=''>{__('Align:', 'swipe-n-buy')}</Label>
            <BtnGroup value={layoutAlign} onChange={val => setAttributes({ layoutAlign: val })} options={aligns} isIcon={true} />
        </PanelRow>
    </PanelBody>
}
export default SwipeLayoutPanel;